module.exports = __webpack_public_path__ + "img/default_user.0cd8ffb8.jpg";